module.exports = __webpack_public_path__ + "static/media/localfnfTwitter-600x314.6a09fc56.jpg";